import { PasswordInput } from '~/components';

export const FormPasswordInput = ({
  value,
  label,
  placeholder,
  onChange,
}: {
  value: string;
  label?: string;
  placeholder?: string;
  onChange: (value: string) => void;
}) => {
  return (
    <div className="space-y-4">
      {label && <div>{label}</div>}

      <PasswordInput
        value={value}
        onChange={onChange}
        placeholder={placeholder}
      />
    </div>
  );
};
